import { useContext, useEffect } from "react";
import { Container, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { TenantContext } from "../../context/tenant/TenantContext";
import { LanguageContext } from "../../context/language/LanguageContext";
import { CLOUDFRONT } from "../../utils/env";
import "./brandednotfound.css";

export default function BrandedNotFound() {
    const { tenant } = useContext(TenantContext);
    const { language } = useContext(LanguageContext);
    const navigate = useNavigate();
    const location = useLocation();

    // Extract tenant URL from path
    const tenantUrlName = location.pathname.split("/")[1];

    useEffect(() => {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        let faviconImg;
        if (tenantUrlName) {
            const cdnFavicon = `${CLOUDFRONT}favicons/${tenantUrlName}.ico`;
            faviconImg = new Image();
            faviconImg.onload = () => { link.href = cdnFavicon; };
            faviconImg.onerror = () => { link.href = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'><rect width='16' height='16' fill='white'/></svg>"; };
            faviconImg.src = cdnFavicon;
        } else {
            link.href = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'><rect width='16' height='16' fill='white'/></svg>";
        }
        return () => {
            if (faviconImg) {
                faviconImg.onload = null;
                faviconImg.onerror = null;
                faviconImg.src = '';
            }
        };
    }, [tenantUrlName]);

    const handleGoHome = () => {
        if (tenantUrlName) {
            navigate(`/${tenantUrlName}`);
        } else {
            navigate("/");
        }
    };

    return (
        <Container className="branded-404-container">
            <div className="branded-404-content">
                <h1 className="branded-404-title">404</h1>
                <p className="branded-404-message">
                    {language?.static_labels?.page_not_found || "Oops, we can't seem to find the page you are looking for"}
                </p>
                <Button 
                    variant="primary" 
                    className="branded-404-button"
                    onClick={handleGoHome}
                >
                    {language?.static_labels?.go_back_home || "Go back home"}
                </Button>
            </div>
        </Container>
    );
}
